// extracted by mini-css-extract-plugin
export default {"SearchBar":"SearchBar_SearchBar__0UN5G","SearchButton":"SearchBar_SearchButton__UBh6D"};